<template>

  <div>

    <div class="need-now-section">
      <span class="need-now-line"></span>
      <p class="need-now-heading">What do you need right now?</p>
      <span class="need-now-line"></span>
    </div>

    <div class="mt-3 d-flex shortcut-container justify-content-between">
      <div class="d-flex flex-column align-items-center" @click="showContractionModal()">
        <contraction-svg></contraction-svg>
        <span>+ Contraction</span>
      </div>
      <router-link to="/meditation_dashboard">
        <div class="d-flex flex-column align-items-center">
          <meditation-svg></meditation-svg>
          <span>+ Meditation</span>
        </div>
      </router-link>
      <router-link to="/community">
        <div class="d-flex flex-column align-items-center">
           <i class="fas fa-hands-helping shortcut-process-icon"></i>
          <span>Request a Process</span>
        </div>
      </router-link>

      <b-modal id="modal-add-contraction" title="Add your contraction" hide-header hide-footer>

        <div class="d-flex flex-column">


          <b-form-textarea
              v-model="contraction"
              placeholder="Briefly describe what happened and what emotions you felt (e.g. anger, fear, sadness). You can also include where you felt it in your body."
              rows="6"
              class="mt-2"
              autofocus
          ></b-form-textarea>

          <div class="mt-3">
            <b-button class="btn btn-sm text-decoration-none" @click="saveContraction" :disabled="loading.save">
              Submit <b-spinner small v-if="loading.save"></b-spinner>
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="hideContractionPopup()">
              Close
            </b-button>
          </div>
        </div>

      </b-modal>

      <add-dream-log
          :readonly="0"
          status="add"
          :active-dream="dream"
          @submitted="hideDreamLogPopup"
          v-if="dream"
      ></add-dream-log>

      <add-feeling-log
          :readonly="0"
          modal_type="add"
          :feeling="{}"
          :feelings="feelings"
          :questions="questions"
          @onAction="onAddFeelingAction"
          v-if="showFeelingsPopup"
      ></add-feeling-log>
    </div>

    <dashboard-stats
        :stats="stats"
        @addDailyLog="showDailyLogPopup"
        @addContraction="showContractionModal"
    ></dashboard-stats>
  </div>
</template>

<script>

import axios from '@/axios';
import ContractionSvg from "@/components/svg/ContractionSvg";
import MeditationSvg from "@/components/svg/MeditationSvg";
import AddDreamLog from "@/components/dreams/AddDreamLog";
import {QUESTIONS, FEELINGS} from "@/components/feelings/data";
import AddFeelingLog from "@/components/feelings/AddFeelingLog";
import DashboardStats from "@/components/Dashboard/DashboardStats.vue";

export default {
  components: {
    DashboardStats,
    MeditationSvg,
    ContractionSvg,
    AddDreamLog,
    AddFeelingLog,
  },
  data() {
    return {
      stats: null,
      contraction: '',
      loading: {
        save: false,
      },
      dream: null,
      showFeelingsPopup: false,

      feelings: FEELINGS,
      questions: QUESTIONS
    }
  },

  methods: {
    async showDailyLogPopup() {

      this.getLatestGoal()
        .then(() => {
          const questions = Object.values(this.questions);
          for (const key of questions) {
            if (key.id === "goal") {
              this.questions["goal"].value = this.goal_latest;
              this.questions["goal"].sanitised_value = this.goal_latest;
            }
          }
        })

      this.showFeelingsPopup = true
      this.$nextTick(() => {
        setTimeout(() => this.$bvModal.show('feelings_wrapper'), 100)
      })
    },


    onAddFeelingAction() {
      this.showFeelingsPopup = false
      this.$root.$emit('dailylog-saved')
    },

    showDreamLogPopup() {
      this.dream = {
        date_edit: (new Date).toISOString().split('T')[0],
        can_comment: true
      }
      this.$nextTick(() => {
        setTimeout(() => this.$bvModal.show('dream_wrapper'), 100)
      })
    },

    hideDreamLogPopup() {
      this.dream = null

      this.$root.$emit('dream-saved')
    },

    showContractionModal() {
      this.$bvModal.show('modal-add-contraction');
    },

    hideContractionPopup() {
      this.$bvModal.hide('modal-add-contraction');
    },

    saveContraction() {

      if (! this.contraction) {
        return
      }

      this.loading.save = true
      axios({
        method: "post",
        url: "contractions/store",
        data: { contraction: this.contraction },
      })
        .then(() => {
          this.contraction = ''
          this.loading.save = false
          this.hideContractionPopup()
          this.getDashboardStats()
        })
    },

    getLatestGoal() {
      const params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("category", "user_feelings_log");
      params.append("limit", "1");
      params.append("order_by", "access");
      params.append("order_direction", "desc");

      return axios({
        url: this.$store.state.api_url + "feelingsGet",
        params: params,
      })
        .then((response) => {
          this.goal_latest = response.data.goal;
        })
    },

    async getDashboardStats() {
      this.stats = await axios.get('/dashboard/stats?days=7').then(resp => resp.data)
    }
  },

  created() {
    this.getDashboardStats()
  }
}

</script>

<style scoped>

/* What do you need right now */
.need-now-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  margin-bottom: 4px;
}

.need-now-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d6b674, transparent);
}

.need-now-heading {
  font-size: 0.78rem;
  font-weight: 700;
  color: #d6b674;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 0;
  white-space: nowrap;
}


.shortcut-container {
  gap: 4px;
  color: #d6b674;
  font-size: 13px;
  margin-bottom: 28px;
}

.shortcut-container > div {
  cursor: pointer;
}

.shortcut-container > div, a {
  flex: 1;
}

a {
  color: #d6b674;
}

a:hover {
  color: #d6b674;
  text-decoration: none;
}

.shortcut-process-icon {
  font-size: 2.4rem;
  color: transparent;
  -webkit-text-stroke: 1.5px #d6b674;
  display: block;
  height: 55px;
  line-height: 55px;
  text-align: center;
}

@media (max-width: 767px) {
  .shortcut-container :deep(svg) {
    width: 46px;
    height: 46px;
  }

  .shortcut-process-icon {
    font-size: 2rem;
    height: 46px;
    line-height: 46px;
  }

  .shortcut-container {
    font-size: 11px;
    margin-bottom: 20px;
  }
}

@media (max-width: 400px) {
  .shortcut-container :deep(svg) {
    width: 38px;
    height: 38px;
  }

  .shortcut-process-icon {
    font-size: 1.6rem;
    height: 38px;
    line-height: 38px;
  }

  .shortcut-container {
    font-size: 10px;
  }
}

@media (min-width: 768px) {
  .shortcut-container :deep(svg) {
    width: 70px;
    height: 70px;
  }

  .shortcut-process-icon {
    font-size: 3rem;
    height: 70px;
    line-height: 70px;
  }
}

</style>
